var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"banner_1"},[_c('m-img',{attrs:{"src":require("@/mobile_plan/assets/image/1.jpg")}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }